export const selectAllCompanyTypes = (state) => state.companyType.companyTypes;
export const selectAllCompanyTypesStatus = (state) => state.companyType.status;
export const selectAllCompanyTypesError = (state) => state.companyType.error;

export const selectAllRoles = (state) => state.role.roles;
export const selectAllRolesStatus = (state) => state.role.status;
export const selectAllRolesError = (state) => state.role.error;

export const selectAllStates = (state) => state.states.states;
export const selectAllStatesStatus = (state) => state.states.status;
export const selectAllStatesError = (state) => state.states.error;
